module.exports = __webpack_public_path__ + "img/classroom1.a8da8a57.svg";